import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// Pipes
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { AgendaEventCardComponent } from './components/agenda-event-card/agenda-event-card.component';
import { CitycardBannerComponent } from './components/citycard-banner/citycard-banner.component';
import { CollapsableListComponent } from './components/collapsable-list/collapsable-list.component';
import { CookiesConfiguratorModalComponent } from './components/cookies-configurator-modal/cookies-configurator-modal.component';
import { CookiesConfiguratorComponent } from './components/cookies-configurator/cookies-configurator.component';
import { DirectionsPopoverComponent } from './components/directions-popover/directions-popover.component';
import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { EventCardComponent } from './components/event-card/event-card.component';
import { ExtraInfoComponent } from './components/extra-info/extra-info.component';
import { FooterComponent } from './components/footer/footer.component';
// Components
import { HeaderComponent } from './components/header/header.component';
import { InputErrorComponent } from './components/input-error/input-error.component';
import { MallSectionHeaderComponent } from './components/mall-section-header/mall-section-header.component';
import { MovieCardComponent } from './components/movie-card/movie-card.component';
import { NewsletterModalComponent } from './components/newsletter-modal/newsletter-modal.component';
import { PromoCardComponent } from './components/promo-card/promo-card.component';
import { RecommendationCardComponent } from './components/recommendation-card/recommendation-card.component';
import { SectionBannerComponent } from './components/section-banner/section-banner.component';
import { ServiceCardComponent } from './components/service-card/service-card.component';
import { ShopsSliderComponent } from './components/shops-slider/shops-slider.component';
import { ShowMoreButtonComponent } from './components/show-more-button/show-more-button.component';
import { SmallServiceCardComponent } from './components/small-service-card/small-service-card.component';
import { LanguageRouterDirective } from './directives/language-router';
import { LazyImgDirective } from './directives/lazy-images';
import { UrlPipe } from './pipes/url.pipe';
import { ShareComponent } from './components/share-component/share.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    RouterModule,
    TranslateModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
  ],
  declarations: [
    // Components
    HeaderComponent,
    RecommendationCardComponent,
    PromoCardComponent,
    ServiceCardComponent,
    FooterComponent,
    MovieCardComponent,
    MallSectionHeaderComponent,
    SectionBannerComponent,
    CollapsableListComponent,
    EventCardComponent,
    AgendaEventCardComponent,
    CitycardBannerComponent,
    ExtraInfoComponent,
    NewsletterModalComponent,
    SmallServiceCardComponent,
    ShopsSliderComponent,
    InputErrorComponent,
    DirectionsPopoverComponent,
    EmptyStateComponent,
    LanguageRouterDirective,
   // LazyImgDirective,
    ShowMoreButtonComponent,
    CookiesConfiguratorModalComponent,
    CookiesConfiguratorComponent,
    ShareComponent,
    // Pipes
    UrlPipe,
  ],
  exports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    TranslateModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    // Components
    HeaderComponent,
    RecommendationCardComponent,
    PromoCardComponent,
    ServiceCardComponent,
    FooterComponent,
    MovieCardComponent,
    MallSectionHeaderComponent,
    SectionBannerComponent,
    CollapsableListComponent,
    EventCardComponent,
    AgendaEventCardComponent,
    CitycardBannerComponent,
    ExtraInfoComponent,
    NewsletterModalComponent,
    SmallServiceCardComponent,
    ShopsSliderComponent,
    InputErrorComponent,
    DirectionsPopoverComponent,
    EmptyStateComponent,
    LanguageRouterDirective,
    // LazyImgDirective,
    ShowMoreButtonComponent,
    CookiesConfiguratorModalComponent,
    CookiesConfiguratorComponent,
    ShareComponent,
    // Pipes
    UrlPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule {}
